<form #form="ngForm" class="form" novalidate>
    <div class="row container-sem-endereco" *ngIf="!entity">
        <div class="col-12">
            <div class="alert alert-info alert-sem-endereco text-center" role="alert">
                <i class="fas fa-map-marker-alt alert-icon" aria-hidden="true"></i>
                <h4>
                    Endereço 
                    <span *ngIf="isEnderecoPrincipal()"> Principal </span>
                    <span *ngIf="isEnderecoCobranca()"> de Cobrança </span>
                    <span *ngIf="isEnderecoEntrega()"> de Entrega </span>
                    não adicionado
                </h4>
    
                <button *ngIf="canInsert()" type="button" class="btn btn-primary btn-add" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Endereço
                </button>        
            </div>
        </div>
    </div>

    <div class="row" *ngIf="entity">
        <div class="col-12">
            <div class="row mb-4" *ngIf="canDelete()">
                <div class="col-12 text-right">
                    <button type="button" class="btn btn-light" (click)="delete()">
                        <i class="far fa-trash-alt" aria-hidden="true"></i> Excluir
                    </button>
                </div>
            </div>


            <div class="row">
                <div class="form-group col-12" [class.col-md-3]="!isMini">
                    <label for="enderecoCep_{{tipoEndereco}}" class="col-form-label">CEP</label>                     
                    <sgt-cep [(ngModel)]="entity.cep" name="enderecoCep_{{tipoEndereco}}" id="enderecoCep_{{tipoEndereco}}"
                        #enderecoCep="ngModel" [ngControl]="enderecoCep" [required]="cepRequired"
                        (cepEncontrado)="onCepEncontrado($event)"
                        [disabled]="!canEdit" [readonly]="!canEdit"
                        [isValidate]="!exterior" [isApplyMask]="!exterior">
                    </sgt-cep>
                    <sgt-form-control-error
                        *ngIf="enderecoCep.errors && enderecoCep.errors.required && enderecoCep.dirty"
                        msgError="O CEP é obrigatório">
                    </sgt-form-control-error>
                </div>
                <div class="form-group col-12" [class.col-md-6]="!isMini">
                        <label for="enderecoLogradouro_{{tipoEndereco}}" class="col-form-label">Logradouro</label>
                        <input type="text" class="form-control" [(ngModel)]="entity.logradouro" name="enderecoLogradouro_{{tipoEndereco}}" id="enderecoLogradouro_{{tipoEndereco}}"
                        #enderecoLogradouro="ngModel" [required]="logradouroRequired" maxlength="255" sgtUppercase
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <sgt-form-control-error
                        *ngIf="enderecoLogradouro.errors && enderecoLogradouro.errors.required && enderecoLogradouro.dirty"
                        msgError="O logradouro é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="enderecoLogradouro.errors && enderecoLogradouro.errors.maxlength"
                        msgError="O logradouro deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>                    
                </div>
                <div class="form-group col-12" [class.col-md-3]="!isMini">
                    <label for="enderecoNumero_{{tipoEndereco}}" class="col-form-label">Número</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.numero" name="enderecoNumero_{{tipoEndereco}}" id="enderecoNumero_{{tipoEndereco}}"
                        #enderecoNumero="ngModel" maxlength="20" sgtUppercase
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <sgt-form-control-error
                        *ngIf="enderecoNumero.errors && enderecoNumero.errors.maxlength"
                        msgError="O número deve ter no máximo 20 caracteres">
                    </sgt-form-control-error>                                       
                </div>                                 
            </div>
            <div class="row">
                <div class="form-group col-12" [class.col-md-6]="!isMini">
                    <label for="enderecoComplemento_{{tipoEndereco}}" class="col-form-label">Complemento</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.complemento" name="enderecoComplemento_{{tipoEndereco}}" id="enderecoComplemento_{{tipoEndereco}}"
                        #enderecoComplemento="ngModel" maxlength="255" sgtUppercase
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <sgt-form-control-error
                        *ngIf="enderecoComplemento.errors && enderecoComplemento.errors.maxlength"
                        msgError="O complemento deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>                                       
                </div>                                              
                <div class="form-group col-12" [class.col-md-6]="!isMini">
                    <label for="enderecoBairro_{{tipoEndereco}}" class="col-form-label">Bairro</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.bairro" name="enderecoBairro_{{tipoEndereco}}" id="enderecoBairro_{{tipoEndereco}}"
                        #enderecoBairro="ngModel" maxlength="255" sgtUppercase
                        [disabled]="!canEdit" [readonly]="!canEdit" [required]="bairroRequired">
                        <sgt-form-control-error
                            *ngIf="enderecoBairro.errors && enderecoBairro.errors.required && enderecoBairro.dirty"
                            msgError="O bairro é obrigatório">
                        </sgt-form-control-error>                            
                    <sgt-form-control-error
                        *ngIf="enderecoBairro.errors && enderecoBairro.errors.maxlength"
                        msgError="O bairro deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>                                       
                </div>
            </div>

            <!-- Dados da cidade do endereço -->
            <sgt-pessoa-endereco-cidade
                #formCidade
                [tipoEndereco]="tipoEndereco"
                [canEdit]="canEdit"
                [entity]="entity"
                [idRepresentante]="idRepresentante"
                [exterior]="exterior"
                [isCliente]="true"
                [cidadeRequired]="false"
                [paisRequired]="false"
                [canSave]="this.canSave()">
            </sgt-pessoa-endereco-cidade>

            <div class="row">
                <div class="form-group col-12" [class.col-md-4]="!isMini">
                    <label for="enderecoInscMunicipal_{{tipoEndereco}}" class="col-form-label">Inscrição Municipal</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.inscricaoMunicipal" name="enderecoInscMunicipal_{{tipoEndereco}}" id="enderecoInscMunicipal_{{tipoEndereco}}"
                        #enderecoInscMunicipal="ngModel" maxlength="20"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <sgt-form-control-error
                        *ngIf="enderecoInscMunicipal.errors && enderecoInscMunicipal.errors.maxlength"
                        msgError="A inscrição municipal deve ter no máximo 20 caracteres">
                    </sgt-form-control-error>                                                               
                </div>
                <div class="form-group col-12" [class.col-md-4]="!isMini">
                    <label for="enderecoInscEstadual_{{tipoEndereco}}" class="col-form-label">Inscrição Estadual</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.inscricaoEstadual" name="enderecoInscEstadual_{{tipoEndereco}}" id="enderecoInscEstadual_{{tipoEndereco}}"
                        #enderecoInscEstadual="ngModel"
                        [disabled]="!canEdit" [readonly]="!canEdit" [required]="inscricaoEstadualRequired">                    
                    <!-- <input type="text" class="form-control" [(ngModel)]="entity.inscricaoEstadual" name="enderecoInscEstadual" id="enderecoInscEstadual"
                        #enderecoInscEstadual="ngModel" [sgtInscricaoEstadual]="ufMascaraIe"> -->
                    <!-- <sgt-form-control-error
                        *ngIf="enderecoInscEstadual.errors && enderecoInscEstadual.errors.ieInvalida"
                        msgError="Inscrição estadual inválida">
                    </sgt-form-control-error>                          -->
                    <sgt-form-control-error
                        *ngIf="enderecoInscEstadual.errors && enderecoInscEstadual.errors.required && enderecoInscEstadual.dirty"
                        msgError="A Inscrição Estadual é obrigatória">
                    </sgt-form-control-error>                        
                    <sgt-form-control-error
                        *ngIf="enderecoInscEstadual.errors && enderecoInscEstadual.errors.maxlength"
                        msgError="A inscrição estadual deve ter no máximo 20 caracteres">
                    </sgt-form-control-error>
                </div>                
                <div class="form-group col-12" [class.col-md-4]="!isMini" *ngIf="exibirInscricaoProdutorRural">
                    <label for="enderecoInscProdutorRural_{{tipoEndereco}}" class="col-form-label">Inscrição Produtor Rural</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.inscricaoProdutorRural" name="enderecoInscProdutorRural_{{tipoEndereco}}" id="enderecoInscProdutorRural_{{tipoEndereco}}"
                        #enderecoInscProdutorRural="ngModel"
                        [disabled]="!canEdit" [readonly]="!canEdit">                       
                    <sgt-form-control-error
                        *ngIf="enderecoInscProdutorRural.errors && enderecoInscProdutorRural.errors.maxlength"
                        msgError="A Inscrição de Produtor Rural deve ter no máximo 20 caracteres">
                    </sgt-form-control-error>
                </div>                
            </div>  
            
            <div class="row" *ngIf="exibirInscricaoSuframa">
                <div class="form-group col-12" [class.col-md-8]="!isMini" [class.col-xl-4]="!isMini">
                    <label class="col-form-label">Possui Inscrição Suframa?</label>
                    <br/>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" class="custom-control-input" name="possuiInscricaoSuframa_{{tipoEndereco}}" id="possuiInscricaoSuframaSim_{{tipoEndereco}}" [value]="true" [(ngModel)]="entity.possuiInscricaoSuframa"
                            #possuiInscricaoSuframa="ngModel" #possuiInscricaoSuframaInput required="required" [attr.disabled]="!canEdit || null" [attr.readonly]="!canEdit || null">                     
                        <label class="custom-control-label" for="possuiInscricaoSuframaSim_{{tipoEndereco}}">Sim</label>
                    </div> 
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" class="custom-control-input" name="possuiInscricaoSuframa_{{tipoEndereco}}" id="possuiInscricaoSuframaNao_{{tipoEndereco}}" [value]="false" [(ngModel)]="entity.possuiInscricaoSuframa"
                            required="required" [attr.disabled]="!canEdit || null" [attr.readonly]="!canEdit || null">                     
                        <label class="custom-control-label" for="possuiInscricaoSuframaNao_{{tipoEndereco}}">Não</label>
                    </div> 
                    <sgt-form-control-error
                        *ngIf="possuiInscricaoSuframa.errors && possuiInscricaoSuframa.errors.required && possuiInscricaoSuframa.dirty"
                        msgError="É obrigatório selecionar se possui ou não a Inscrição Suframa">
                    </sgt-form-control-error>   
                    <p class="form-text text-muted">
                        Selecione Sim quando este lead possuir Inscrição Suframa
                    </p>                         
                </div>                
                <div class="form-group col-12" [class.col-md-4]="!isMini" *ngIf="entity.possuiInscricaoSuframa">
                    <label for="enderecoInscSuframa_{{tipoEndereco}}" class="col-form-label">Inscrição Suframa</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.inscricaoSuframa" name="enderecoInscSuframa_{{tipoEndereco}}" id="enderecoInscSuframa_{{tipoEndereco}}"
                        #enderecoInscSuframa="ngModel" #enderecoInscSuframaInput required="required" maxlength="20"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <sgt-form-control-error
                        *ngIf="enderecoInscSuframa.errors && enderecoInscSuframa.errors.required && enderecoInscSuframa.dirty"
                        msgError="A Inscrição Suframa é obrigatória quando o lead possuir esta inscrição">
                    </sgt-form-control-error>                            
                    <sgt-form-control-error
                        *ngIf="enderecoInscSuframa.errors && enderecoInscSuframa.errors.maxlength"
                        msgError="A Inscrição Suframa deve ter no máximo 20 caracteres">
                    </sgt-form-control-error>                                                               
                </div>                
            </div>
        </div>
    </div>
</form>
    